/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Clipboard(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M160.00049,40A39.82135,39.82135,0,0,1,168,64v8H88V64a39.82135,39.82135,0,0,1,7.99951-24H56a7.99977,7.99977,0,0,0-8,8V216a7.99977,7.99977,0,0,0,8,8H200a7.99977,7.99977,0,0,0,8-8V48a7.99977,7.99977,0,0,0-8-8Z"
        opacity={0.2}
      />
      <Path
        d="M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M88,72V64a40,40,0,0,1,80,0v8Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Clipboard;
